export default "__VITE_ASSET__86a8c745__"